import { Badge } from '@avanta/shared/components/ui/Badge';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useTranslation } from 'react-i18next';
import { ColorByScore, ScoreRange } from 'pages/Pae/components/BarometerResults/types';

export const getBadgePropsByScore = (score: number): { color: string; label: string } => {
  if (score >= 0 && score <= 20) return { color: ColorByScore.veryLow, label: ScoreRange.veryLow };
  if (score >= 21 && score <= 40) return { color: ColorByScore.low, label: ScoreRange.low };
  if (score >= 41 && score <= 60) return { color: ColorByScore.medium, label: ScoreRange.medium };
  if (score >= 61 && score <= 80) return { color: ColorByScore.high, label: ScoreRange.high };
  return { color: ColorByScore.fullyCharged, label: ScoreRange.fullyCharged };
};

export interface GeneralBadgeProps {
  score: number;
  maxScore: number;
  className?: string;
}

export const GeneralBadge = ({
  score,
  maxScore,
  className,
}: GeneralBadgeProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.WELL_BEING);
  const normalizedScore = maxScore > 0 ? Math.round((score / maxScore) * 100) : 0;
  const { color, label } = getBadgePropsByScore(normalizedScore);

  return (
    <Badge size="md" className={cn(className, color, 'text-white')}>
      {t(`BarometerResults.General.Badge.${label}`)}
    </Badge>
  );
};
